import { u8aToHex } from '../helpers';
export function publicKeyGrid(publicKey) {
    const hex = u8aToHex(publicKey);
    let grid = '';
    for (let i = 0; i < hex.length; i++) {
        if (i % 8 === 0 && i > 0 && i < 63) {
            grid += '\n';
        }
        if (i % 8 > 0) {
            grid += ' ';
        }
        grid += hex[i];
    }
    return grid;
}
